import * as React from 'react';
import { clsx } from 'clsx';
import { useDeviceType } from '../../../../responsive';
import { CloseButton } from '../../../../internal/components/CloseButton';
import { Overlay } from '../../../internal/components';
import { getStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var modalWindowViewDefaultProps = {
  size: 'M',
  fixed: false,
  outside: true,
  print: true,
  hideCloseButton: false
};

/**
 * Компонент для рендера модального окна в виде окошка с крестиком внутри
 */
export function ModalWindowView(props) {
  var children = props.children,
    onClose = props.onClose,
    _props$size = props.size,
    size = _props$size === void 0 ? modalWindowViewDefaultProps.size : _props$size,
    _props$fixed = props.fixed,
    fixed = _props$fixed === void 0 ? modalWindowViewDefaultProps.fixed : _props$fixed,
    _props$outside = props.outside,
    outside = _props$outside === void 0 ? modalWindowViewDefaultProps.outside : _props$outside,
    _props$print = props.print,
    print = _props$print === void 0 ? modalWindowViewDefaultProps.print : _props$print,
    _props$hideCloseButto = props.hideCloseButton,
    hideCloseButton = _props$hideCloseButto === void 0 ? modalWindowViewDefaultProps.hideCloseButton : _props$hideCloseButto,
    content = props.content,
    header = props.header,
    footer = props.footer,
    title = props.title,
    width = props.width,
    height = props.height,
    maxWidth = props.maxWidth,
    maxHeight = props.maxHeight,
    zIndex = props.zIndex;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType, size);
  return /*#__PURE__*/_jsx(Overlay, {
    zIndex: zIndex,
    onClose: onClose,
    outside: outside,
    print: print,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(styles['container'], styles[size], fixed && styles['fixed'], !!header && styles['withHeader']),
      style: {
        width: width,
        height: height,
        maxWidth: maxWidth,
        maxHeight: maxHeight
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: styles['window'],
        "aria-modal": "true",
        role: "dialog",
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['head'],
          children: [!hideCloseButton && /*#__PURE__*/_jsx(CloseButton, {
            className: styles['close'],
            onClick: onClose,
            size: 16,
            theme: "dark"
          }), title && /*#__PURE__*/_jsx("div", {
            className: clsx(styles['title']),
            children: title
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['body'],
          children: [header && /*#__PURE__*/_jsx("div", {
            className: styles['header'],
            children: header
          }), /*#__PURE__*/_jsx("div", {
            className: styles['content-container'],
            children: children || /*#__PURE__*/_jsx("div", {
              className: styles['content'],
              children: content
            })
          }), footer && /*#__PURE__*/_jsx("div", {
            className: styles['footer'],
            children: footer
          })]
        })]
      })
    })
  });
}